import styled, { css } from 'styled-components'

import { TaskPriority } from './TaskObjectCard.types'

const backgroundByPriority: Record<TaskPriority, string> = {
  low: '#ABBED1',
  normal: '#60B878',
  high: '#DC890D',
  urgent: '#A72121'
}

export const PriorityBadge = styled.div<{ priority: TaskPriority }>`
  position: absolute;
  top: -5px;
  right: 8px;
  width: 46px;
  height: 12px;
  line-height: 12px;
  font-size: 8px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  color: ${({ priority }) => (priority === 'urgent' ? '#FFFFFF' : '#323232')};
  background: ${({ priority }) => backgroundByPriority[priority]};
`

export const Container = styled.div`
  position: relative;
  width: 100%;

  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    margin: 0;
  }

  hr {
    margin: 0;
    opacity: 1;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Description = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
`

export const TaskActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
`

export const TaskActionsRow = styled.div`
  display: flex;
  gap: 6px;
  flex: 1 0 40%;
  width: 100%;

  &:first-child,
  &:last-child:nth-child(even) {
    flex: auto;
  }
`

export const FieldsRow = styled.div<{ $gridTemplate: string }>`
  display: grid;
  gap: 8px;
  overflow: hidden;
  ${({ $gridTemplate }) => `grid-template-columns: ${$gridTemplate};`}
`

export const UserBlocks = styled.div<{ $length: number }>`
  ${({ $length }) =>
    $length <= 2
      ? css`
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        `
      : css`
          display: flex;
          max-width: 100%;
          overflow-x: auto;
          flex-wrap: nowrap;
          white-space: nowrap;
          gap: 1rem;
          min-width: 100%;
          padding-bottom: 8px;

          > div {
            min-width: fit-content;
          }
        `}
`

export const UserBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 10px;
  line-height: 12px;
`

export const UserAvatar = styled.div`
  display: flex;
  gap: 8px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  align-items: center;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
`

export const ValueContainer = styled.div`
  font-family: Barlow;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin: 0;
  padding-left: 8px;
  white-space: nowrap;
`
